<template>
  <div>

    <help :text="$t('help.tievent_create')" :title="$t('help.tievent_create_title')"/>

    <div :key="$store.getters['resource/currentResource'].key">
      <event-view @save="saveEvent" />
    </div>
  </div>
</template>

<script>
  import EventView from "./TiEventView.vue";

  export default {
    components: {
      EventView
    },
    middleware: 'auth',
    name: 'EventCreation',
    methods: {
      saveEvent(params) {
        this.postData('ti-event', params, '/tievents');
      }
    }

  }
</script>